import IManagementDriver from '../../../NativeDevice/Management/IManagementDriver';
import { HandlerResult } from '../IHandler';
import { IMdcSendOneMessage, INmcSendOneMessage } from './IMDCSendOneMessage';
import { ManagementCapabilities } from '@signageos/common-types/dist/Device/Capabilities/ManagementCapabilities';
import { IMdcSendOneResponse } from '../../../NativeDevice/NativeCommand/MDC/IMdc';

const PREFIX = 'native_commands';

export function* handleNativeCommandMessage(
	messageTypePrefix: string,
	data: IMdcSendOneMessage | INmcSendOneMessage,
	managementDriver: IManagementDriver,
): HandlerResult {
	switch (data.type) {
		case `${messageTypePrefix}.${PREFIX}.mdc.send_one`:
			return yield handleMdcSendOne(data as IMdcSendOneMessage, managementDriver, false);
		case `${messageTypePrefix}.${PREFIX}.mdc.send_one_raw`:
			return yield handleMdcSendOne(data as IMdcSendOneMessage, managementDriver, true);
		case `${messageTypePrefix}.${PREFIX}.nmc.send_one`:
			return yield handleNmcSendOne(data as INmcSendOneMessage, managementDriver);
		default:
			return null;
	}
}

export default function* nativeCommandHandler({ messageTypePrefix, data, managementDriver }: any): HandlerResult {
	return yield handleNativeCommandMessage(messageTypePrefix, data, managementDriver);
}

async function handleMdcSendOne(
	data: IMdcSendOneMessage,
	managementDriver: IManagementDriver,
	raw: boolean,
): Promise<{ commandResponse: IMdcSendOneResponse }> {
	const isSupported = await managementDriver.managementSupports(ManagementCapabilities.NATIVE_COMMANDS_MDC);
	if (!isSupported) {
		throw new Error('Native MDC commands are not supported on this device.');
	}
	if (raw) {
		const rawCommandResponse = await managementDriver.nativeCommands.mdc.sendOneRaw(data.ipAddress, data.data);
		return { commandResponse: rawCommandResponse };
	}
	const commandResponse = await managementDriver.nativeCommands.mdc.sendOne(data.ipAddress, data.command, data.data);
	return { commandResponse };
}

async function handleNmcSendOne(
	data: INmcSendOneMessage,
	managementDriver: IManagementDriver,
): Promise<{ commandResponse: IMdcSendOneResponse }> {
	const isSupported = await managementDriver.managementSupports(ManagementCapabilities.NATIVE_COMMANDS_NMC);
	if (!isSupported) {
		throw new Error('Native NMC commands are not supported on this device.');
	}
	const commandResponse = await managementDriver.nativeCommands.nmc.sendOne(data.ipAddress, data.command, data.data);
	return { commandResponse };
}
